import React, { useContext } from 'react'
import LogoImage from 'app/assets/logo.png'
import LogoChristmasImage from 'app/assets/logo-christmas.png'
import SettingsContext from 'modules/settings/context'
import { findOnArray } from 'reacticoon/utils/array'

const LogoIcon = ({ png, ...props }) => {
  const settings = useContext(SettingsContext)
  const activeThemeSetting = findOnArray(settings || [], setting => setting.name === 'activeTheme')
  const activeTheme = activeThemeSetting?.value || 'default'
  
  const logoSrc = activeTheme === 'christmas' ? LogoChristmasImage : LogoImage
  
  return <img src={logoSrc} alt="logo" {...props} />
}

export default LogoIcon
